<template>
  <BaseEditor
    data-test-id="editAdmin"
    v-bind="$attrs"
    v-model="store.showEditDialog"
    :table-store-id="TableStoreId.Admins"
    :title="title"
    :max-width="400"
    :min-height="400"
    @save-item="saveItem"
  >
    <v-form :fast-fail="false" @submit.prevent ref="editAdminForm">
      <v-row>
        <v-col cols="12">
          <PrimaryTextField
            required
            :label="t('fields.admins.firstName')"
            :maxlength="64"
            v-model.trim="item.firstName"
            :rules="RulesManager.getRules(Rule.Required)"
          />
          <PrimaryTextField
            required
            :label="t('fields.admins.lastName')"
            :maxlength="64"
            v-model.trim="item.lastName"
            :rules="RulesManager.getRules(Rule.Required)"
          />
          <PrimaryTextField
            required
            :label="t('fields.admins.email')"
            :maxlength="64"
            v-model.trim="item.email"
            :rules="RulesManager.getRules([Rule.ValidEmail, Rule.Required])"
          />
          <PrimarySelect
            v-model="item.role"
            :label="t('fields.admins.role')"
            :items="store.roles"
          ></PrimarySelect>
          <EditEvent />
        </v-col>
      </v-row>
    </v-form>
  </BaseEditor>
</template>

<script setup lang="ts">
// STORES, IMPORTS, & COMPOSABLES
import { useRulesManager } from '@/composables/RulesManager'
import { Rule } from '@/enums/Rule'
import { TableStoreId } from '@/enums/TableStoreId'
import type { IAdminsStore } from '@/interfaces/api/IAdminsStore'
import { AdminRecord } from '@/models/AdminRecord'
import { TableStoreFactory } from '@/stores/db/TableStoreFactory'
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'

const store = TableStoreFactory.get(TableStoreId.Admins) as IAdminsStore
const RulesManager = useRulesManager()
const { t } = useI18n({ useScope: 'global' })

// PROPS & EMITS

// REACTIVE VARIABLES
const editAdminForm = ref<any>()

// COMPUTED PROPERTIES
const item = computed(() => {
  if (!store.selectedItem) {
    return new AdminRecord()
  }
  return store.selectedItem as AdminRecord
})

const title = computed((): string => {
  if (item.value?.id) {
    return t('dialogs.headers.editAdmin')
  }
  return t('dialogs.headers.createAdmin')
})

// WATCHERS

// LIFECYCLE HOOKS

// FUNCTIONS
const saveItem = async () => {
  const { valid } = await editAdminForm.value.validate()
  if (!valid) {
    return
  }

  await store.save()
}
</script>
